<template>
  <div>
    <div class="page-header page-header-settings">
      <div class="logo-wrap">
        <img v-if="activeCharityInfo && activeCharityInfo.logo_transparent"
             :src="activeCharityInfo.logo_transparent"
             :alt="activeCharityInfo.charity_name"
             class="logo"
        >
      </div>
      <div class="page-header-content">
        <div class="page-header-title">
          <div>Settings</div>
          <p>Set up your account and control your organization’s settings</p>
        </div>
      </div>
    </div>
    <div class="page-header-links">
      <router-link :to="{name: 'settingsAccount'}" :class="{active: $route.name === 'settingsAccount'}">
        My Account
      </router-link>
      <router-link :to="{name: 'settingsOrganization'}" :class="{active: $route.name === 'settingsOrganization'}">
        Organization
      </router-link>
      <router-link :to="{name: 'settingsTeammates'}" :class="{active: $route.name === 'settingsTeammates'}">
        Teammates
      </router-link>
      <router-link :to="{name: 'settingsStripe'}" :class="{active: $route.name === 'settingsStripe'}">
        Stripe
      </router-link>
      <router-link :to="{name: 'settingsBilling'}" :class="{active: $route.name === 'settingsBilling'}">
        Billing
      </router-link>
      <router-link :to="{name: 'settingsNotifications'}" :class="{active: $route.name === 'settingsNotifications'}">
        Notifications
      </router-link>
      <router-link :to="{name: 'settingsWebsiteCode'}" :class="{active: $route.name === 'settingsWebsiteCode'}">
        Website Code
      </router-link>
      <router-link :to="{name: 'settingsIntegrations'}" :class="{active: $route.name === 'settingsIntegrations'}">
        Integrations
      </router-link>
      <router-link v-if="false"
                   :to="{name: 'settingsNotifications'}" :class="{active: $route.name === 'settingsNotifications'}">
        Notifications
      </router-link>
      <router-link v-if="false"
          :to="{name: 'settingsCustomFields'}" :class="{active: $route.name === 'settingsCustomFields'}">
        Custom Fields
      </router-link>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: 'SettingsMenu',
    computed: {
      ...mapState({
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
    },
  };
</script>
<style lang="sass">
  .page-header-settings .logo-wrap
    display: flex
    align-items: center
</style>
